import { Card, CardHeader } from '../../../../components/ui/Card';
import { Badge } from '../../../../components/ui/Badge';
import { useVisibilityEngines, useVisibilityTags } from '../../../../hooks/useVisibility';
import { BrandAdmin } from './shared/BrandAdmin';
import { PROVIDER_LABELS } from '../format';

export function ProfilePage() {
  const { data: engines } = useVisibilityEngines();
  const { data: tags } = useVisibilityTags();

  return (
    <div className="space-y-5">
      <BrandAdmin />
      <Card padding="md">
        <CardHeader
          title="Engines"
          description="LLM engines the OS probes daily. Engine availability is code-defined; toggle activity in the backend."
        />
        {(engines?.items ?? []).length === 0 ? (
          <p className="text-body-sm text-text-tertiary">No engines configured.</p>
        ) : (
          <ul className="space-y-2">
            {(engines?.items ?? []).map((e) => (
              <li key={e.id} className="flex items-center justify-between border-b border-border-light pb-2 last:border-0">
                <div>
                  <p className="font-medium text-body-sm">{e.description}</p>
                  <p className="text-body-xs text-text-tertiary">{PROVIDER_LABELS[e.provider] ?? e.provider} · {e.currentModel} · {e.mode}</p>
                </div>
                <Badge variant={e.isActive ? 'success' : 'default'}>{e.isActive ? 'Active' : 'Paused'}</Badge>
              </li>
            ))}
          </ul>
        )}
      </Card>
      <Card padding="md">
        <CardHeader
          title="Intent tags"
          description="Tags applied to prompts to group them by buyer intent and drive recommendation priority."
        />
        {(tags?.items ?? []).length === 0 ? (
          <p className="text-body-sm text-text-tertiary">No tags defined yet.</p>
        ) : (
          <div className="flex flex-wrap gap-1.5">
            {(tags?.items ?? []).map((t) => (
              <Badge key={t.id}>{t.name}</Badge>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
